function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.0006,
  cy: 17.0001,
  r: 11.1,
  stroke: "#8A909F",
  strokeWidth: 1.6
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3008 18.0917V9.5629C15.3008 9.26836 15.3969 9.01224 15.5891 8.80734C15.7813 8.60245 16.0216 8.5 16.298 8.5C16.5743 8.5 16.8146 8.60245 17.0068 8.80734C17.199 9.01224 17.2951 9.26836 17.2951 9.5629V17.4386L21.6082 20.1151C21.8485 20.2687 21.9927 20.4864 22.0647 20.7682C22.1368 21.0499 22.1008 21.3188 21.9566 21.5621C21.7644 21.9207 21.476 22.1 21.0916 22.1C20.8874 22.1 20.7192 22.0488 20.587 21.9463L15.9976 19.0906C15.7934 19.0266 15.6252 18.8985 15.493 18.7192C15.3609 18.5399 15.3008 18.335 15.3008 18.0917Z",
  fill: "#8A909F"
});

var SvgWaitResponseIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWaitResponseIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wait-response-icon.3144d6ec.svg";
export { ForwardRef as ReactComponent };